import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import * as Raven from 'raven-js'
import { ThemeProvider } from 'styled-components'
import theme from 'web-makeup/dist/theme'
import { getLocaleFromBrowserLanguage } from 'web-fns/dist/language'
import 'ant-design-pro/dist/ant-design-pro.css'

import App from './components/App'
import StockDataProvider from './components/StockDataProvider'
import ErrorBoundary from './components/ErrorBoundary'
import * as serviceWorker from './registerServiceWorker'
import ApolloProvider from './components/ApolloProvider'
import CloudinaryContext from './components/CloudinaryContext'
import GoogleContext from './components/GoogleContext'
import styleGlobal from './style'

styleGlobal()

if (window.env && window.env.SENTRY_DSN) {
  Raven.config(window.env.SENTRY_DSN).install()
}

if (window.env && window.env.APPLICATION_TAG) {
  Raven.setRelease(window.env.APPLICATION_TAG)
}

export const render = (Component, el = document.getElementById('root') as HTMLElement) => {
  if (!window.env) {
    return
  }

  ReactDOM.render(
    <ErrorBoundary>
      <GoogleContext.Provider
        value={{
          MAPS_API_KEY: window.env.GOOGLE_MAPS_API_KEY,
          SIGNIN_CLIENT_ID: window.env.GOOGLE_SIGNIN_CLIENT_ID,
        }}
      >
        <CloudinaryContext.Provider
          value={{
            UPLOAD_PRESET: window.env.CLOUDINARY_UPLOAD_PRESET,
            DOWNLOAD_URL: window.env.CLOUDINARY_DOWNLOAD_URL,
            UPLOAD_URL: window.env.CLOUDINARY_UPLOAD_URL,
            CLOUDINARY_USER: window.env.CLOUDINARY_USER,
          }}
        >
          <ThemeProvider theme={theme}>
            <StockDataProvider locale={getLocaleFromBrowserLanguage(window.navigator)}>
              <ApolloProvider>
                <Router>
                  <Component />
                </Router>
              </ApolloProvider>
            </StockDataProvider>
          </ThemeProvider>
        </CloudinaryContext.Provider>
      </GoogleContext.Provider>
    </ErrorBoundary>,
    el
  )
}

render(App)

serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.tsx